import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  CircularProgress,
  Paper,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  Error as ErrorIcon,
  CheckCircle as CheckCircleIcon,
  List as ListIcon,
} from '@mui/icons-material';
import TPosiblesCobros from '../TPosiblesCobros';
import {
  obtenerPosiblesCobros,
  obtenerPosiblesCobrosAsignados,
  obtenerPosiblesCobrosSinAsignar,
} from '../../../actions/CobranzasAction';
export default function PanelPrincipalPosiblesCobros() {
  const [data, setData] = useState([]);
  const [radioValor, setRadioValor] = useState('SinAsignar');
  const [datosCargados, setDatosCargados] = useState(false);
  const radioValorHandleChange = (event) => {
    setRadioValor(event.target.value);
  };

  useEffect(() => {
    switch (radioValor) {
      case 'SinAsignar':
        obtenerPosiblesCobrosSinAsignar().then((response) => {
          if (response.status === 200) {
            setData(response.data);
            setDatosCargados(true);
          } else {
            console.log('ERROR EN TRAER PCSA');
          }
        });
        break;
      case 'Asignados':
        obtenerPosiblesCobrosAsignados().then((response) => {
          if (response.status === 200) {
            setData(response.data);
            setDatosCargados(true);
          } else {
            console.log('ERROR EN TRAER PCA');
          }
        });
        break;

      default:
        obtenerPosiblesCobros().then((response) => {
          if (response.status === 200) {
            setData(response.data);
            setDatosCargados(true);
          } else {
            console.log('ERROR EN TRAER PC');
          }
        });
    }
  }, [radioValor]);
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -20,
            top: -20,
            opacity: 0.2,
          }}
        >
          <ReceiptIcon sx={{ fontSize: 120, transform: 'rotate(-15deg)' }} />
        </Box>
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="white"
            sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}
          >
            <ReceiptIcon sx={{ fontSize: 40 }} />
            Posibles Cobros
          </Typography>
          {datosCargados && (
            <Chip
              label={`${data.length} registros`}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                fontWeight: 600,
              }}
            />
          )}
        </Box>
      </Paper>

      {/* Filters */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <RadioGroup
          row
          value={radioValor}
          onChange={radioValorHandleChange}
          sx={{ gap: 2, flexWrap: 'wrap' }}
        >
          <FormControlLabel
            value="SinAsignar"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ErrorIcon sx={{ fontSize: 20, color: 'error.main' }} />
                <Typography>Sin Asignar</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="Asignados"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />
                <Typography>Asignados</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="todos"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ListIcon sx={{ fontSize: 20 }} />
                <Typography>Todos</Typography>
              </Box>
            }
          />
        </RadioGroup>
      </Paper>

      {/* Content */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {datosCargados ? (
          <TPosiblesCobros rows={data} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="h6" color="text.secondary">
              Cargando posibles cobros...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
